'use client';
import React, { useState } from 'react';
import { toast } from 'sonner';
import { Loader2 } from 'lucide-react';

export default function NewsletterForm() {
  const [email, setEmail] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [done, setDone] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email.trim()) return;
    setSubmitting(true);
    try {
      const res = await fetch('/api/newsletter', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });
      const result = await res.json();
      if (!res.ok) {
        toast.error(result.error ?? 'Failed to subscribe. Please try again.');
        return;
      }
      setDone(true);
      setEmail('');
      toast.success('Successfully subscribed to Hadatha updates!');
    } catch {
      toast.error('Network error. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  if (done) {
    return (
      <div className="bg-primary/10 border border-primary/20 rounded-xl p-5">
        <h4 className="text-sm font-700 text-foreground mb-1">✓ You&apos;re subscribed!</h4>
        <p className="text-xs text-muted-foreground">You&apos;ll receive updates on new releases, tour dates, and exclusive content.</p>
      </div>
    );
  }

  return (
    <div className="bg-primary/10 border border-primary/20 rounded-xl p-5">
      <h4 className="text-sm font-700 text-foreground mb-1">Stay Updated</h4>
      <p className="text-xs text-muted-foreground mb-3">Get tour dates, new releases & exclusive content.</p>
      <form onSubmit={handleSubmit} className="flex gap-2">
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="your@email.com"
          required
          className="flex-1 min-w-0 px-3 py-2 text-xs bg-input border border-border rounded-lg text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-1 focus:ring-ring"
        />
        <button
          type="submit"
          disabled={submitting}
          className="px-3 py-2 text-xs font-600 bg-gradient-gold text-primary-foreground rounded-lg hover:opacity-90 active:scale-95 transition-all shrink-0 disabled:opacity-60 flex items-center gap-1"
        >
          {submitting ? <Loader2 size={12} className="animate-spin" /> : 'Subscribe'}
        </button>
      </form>
    </div>
  );
}
